<template>
    <div class="union-of-aries_splash">
        <div v-if="loading" class="loadOver">
            <div class="loader">
                <div class="loadingGif"></div>
            </div>
        </div>
        <div class="splash_upcoming rsvp password">
            <img src="./assets/images/bg-wingtip-appiarius.jpg" />

            <div class="text-box">
                <router-link to="/" class="link-style">
                    &#8610; &nbsp;&nbsp;Main Page
                </router-link>
                <h6 class="margin-top-spacer">Password</h6>

                <span><i>Enter the password from the password card included in your invite.  If you've lost your password, just text or facebook us, we'd love to hear from you!</i></span>

                <input v-model="password" placeholder="enter your password here" v-on:keyup.enter="passwordCheck" style="text-transform: uppercase;" />
                <button class="button-style" v-on:click="passwordCheck">submit</button>
                <hr class="rsvp-divider" v-if="badPassword"/>
            </div>

            <div class="text-box" v-if="badPassword">
				<h6 class="margin-top-spacer">
					Weird Password
				</h6>

                <div class="rsvp-card">
                    <span>Try again - that's not the password we gave you.
                        We know our passwords were weird, but that's just <i>odd.</i></span>
                </div>
            </div>
        </div>
        <div>
            <!-- <img src="./assets/images/ready.gif"> -->
        </div>
    </div>

</template>

<script>
import { db, rsvpsRef } from './firebase';

export default {
    name: 'rsvp',
    data () {
        return {
            password: null,
            badPassword: false,
            loading: false,
        }
    },
    methods: {
        passwordCheck: function() {
            let datum = this;
            if (!datum.password) { return; }
            datum.loading = true;
            rsvpsRef.doc(datum.password.toUpperCase().replace(" ", "")).get().then(
                function(doc) {
                    if (doc.exists) {
                        // doc.data() is never undefined for query doc snapshots
                        datum.$router.push({ path: `/rsvp/${doc.id}` });
                        datum.badPassword = false;
                    } else {
                        datum.badPassword = true;
                        datum.loading = false;
                    }
                }
            ).catch(function(error) {
                console.log("Error getting documents: ", error);
            });
        },
    },
    components: {
    }
}
</script>




// WEBPACK FOOTER //
// src/RSVP.vue